import { userApiPost } from './apiPost'

export const getOrganizationInformation = userApiPost('get-organization')

export const setOrganizationInformation = userApiPost('set-organization-info')
